"use strict";

define('service/navigation',['require','exports','module','appkit/service','langs','../config','modernizr','rs/models/session'],function (require, exports, module) {
  Service = require('appkit/service');
  langs = require('langs');
  config = require('../config');
  Modernizr = require('modernizr');
  Session = require('rs/models/session');
  var p = langs.phrase;
  var staticRoot = config.staticRoot;
  var usePushState = config.usePushState;
  var isOneLogin = Session.isOneLogin();
  var REPORTING_OPTIONS = [];
  var BETA_REPORT_OPTION = {
    text: p('App.Nav.Reporting.Beta'),
    name: 'reporting:list:beta',
    authorities: ['PERM_BETA_REPORTING'],
    link: resolve('report/list/beta')
  };
  var CLASSIC_REPORT_OPTION = {
    text: p('App.Nav.Reporting.Classic'),
    name: 'reporting:list',
    link: resolve('report/list/custom')
  };
  if (isOneLogin) {
    REPORTING_OPTIONS.push(BETA_REPORT_OPTION);
  }
  REPORTING_OPTIONS.push(CLASSIC_REPORT_OPTION);
  function resolve(route) {
    return usePushState ? staticRoot + '/' + route : '#' + route;
  }
  ;
  var PAGE_NAVIGATION = [{
    text: p('App.Nav.Dashboard'),
    name: 'dashboard:index',
    link: resolve('dashboard')
  }, {
    text: p('App.Nav.Studies'),
    name: 'study:list',
    link: resolve('study/list/active')
  }, {
    text: p('App.Nav.Submission'),
    name: 'submission:list',
    link: resolve('submission/list')
  }, {
    text: p('App.Nav.Tasks'),
    name: 'task:list',
    link: resolve("task/list"),
    'data-name': 'tasks'
  }, {
    text: p('App.Nav.Meetings'),
    name: 'meeting:list',
    link: resolve('meeting/list'),
    'data-name': 'meetings',
    authorities: ['PERM_VIEW_MEETING']
  }, {
    text: p('App.Nav.Reporting'),
    feature: 'reporting',
    inverted: false,
    tree: false,
    'data-name': 'reporting',
    children: REPORTING_OPTIONS
  }, {
    text: p('App.Nav.More'),
    name: 'more',
    authorities: ['PERM_IRB_ADMIN', 'PERM_ADMIN', 'PERM_EFORMS_MODIFY_TEMPLATE', 'PERM_VIEW_LETTERTEMPLATE', 'PERM_MODIFY_IRB_PROPERTY'],
    inverted: false,
    tree: true,
    children: [{
      text: p('App.Nav.Tasks'),
      name: 'task:list',
      link: resolve("task/list"),
      'data-name': 'tasks'
    }, {
      text: p('App.Nav.Meetings'),
      name: 'meeting:list',
      link: resolve('meeting/list'),
      'data-name': 'meetings',
      authorities: ['PERM_VIEW_MEETING']
    }, {
      sectionDivider: true,
      header: true,
      text: p('App.Nav.Reporting'),
      feature: 'reporting',
      'data-name': 'reporting',
      children: REPORTING_OPTIONS
    }, {
      text: p('App.Nav.Admin'),
      link: '/rs/admin/',
      authorities: ['PERM_ADMIN'],
      target: '_blank',
      featureFlag: 'legacyAdmin'
    }, {
      text: p('App.Nav.LegacyUpload'),
      link: resolve('legacy'),
      users: ['cayuseadmin']
    }, {
      text: p('App.Nav.Settings'),
      sectionDivider: true,
      header: true,
      authorities: ['PERM_MODIFY_IRB_PROPERTY', 'PERM_IRB_ADMIN'],
      children: [{
        text: p('App.Nav.AppSettings'),
        link: resolve('application/settings'),
        authorities: ['PERM_MODIFY_IRB_PROPERTY']
      }, {
        text: p('App.Nav.IRB'),
        link: resolve('board/list'),
        authorities: ['PERM_IRB_ADMIN']
      }, {
        text: p('App.Nav.OrgApprovers'),
        link: resolve('organization/list'),
        authorities: ['PERM_IRB_ADMIN']
      }]
    }, {
      text: p('App.Nav.Templates'),
      sectionDivider: true,
      header: true,
      children: [{
        text: p('App.Nav.ChecklistTemplates'),
        link: resolve('template/checklist'),
        authorities: ['PERM_EFORMS_MODIFY_TEMPLATE']
      }, {
        text: p('App.Nav.LetterTemplates'),
        name: 'letterTemplate:list',
        link: resolve('letter/template/list'),
        authorities: ['PERM_VIEW_LETTERTEMPLATE']
      }, {
        text: 'Messages',
        name: 'messageTemplate:list',
        link: resolve('message/template/list'),
        authorities: ['PERM_MODIFY_MESSAGE_TEMPLATE']
      }, {
        text: p('App.Nav.SubmissionTemplates'),
        link: resolve('template/submission'),
        authorities: ['PERM_EFORMS_MODIFY_TEMPLATE']
      }]
    }]
  }];
  var NavigationService = Service.extend({
    inject: [],
    replies: {
      'navigationList': 'navigationList'
    },
    events: {
      'authenticated': 'onAuthenticated'
    },
    onAuthenticated: function onAuthenticated(user) {
      this.user = user;
    },
    navigationList: function navigationList() {
      return this.channel.request('filterNavigationList', PAGE_NAVIGATION, this.user);
    }
  });
  NavigationService.PAGE_NAVIGATION = PAGE_NAVIGATION;
  module.exports = NavigationService;
});

